/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelMortgage = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="panel--wrapper panel--pieslider panel--mortgage isLoading" family="{{ key }}" id="{{ eid }}" data-mortgage=\'{% data_pieslider %}\'>' +
      '    <div class="panel--main">' +
      '        <div class="panel--content">' +
      '            <div class="mortgage--header">' +
      '                <div id="mortgage_graph">' +
      '                    <svg id="mortgage_graphs">' +
      '                        <circle class="graph--base" r="90" cx="100" cy="100" id="graph--base"></circle>' +
      '                        <circle class="graph--pay"  r="90" cx="100" cy="100" id="graph--pay"></circle>' +
      '                    </svg>' +
      '                    <div id="mortgage_limit" class="pieslider_limiter"></div>' +
      '                    <div id="mortgage_rest">€193.000,20</div>' +
      '                    <div id="mortgage_month">€707,40</div>' +
      '                </div>' +
      '            </div>' +
      '            <div class="mortgage--form">' +
      '                <div class="inline--input">' +
      '                    <div class="pm--button minus"></div>' +
      '                    <div class="pm--button plus"></div>' +
      '                    <div class="percentage" id="mortgage_percentage">' +
      '                    0%' +
      '                    </div>' +
      '                </div>' +
      '                <div class="inline--input">' +
      '                    <label>{% amount_placeholder %}</label>' +
      '                    <input type="text" id="id_pay_amount" placeholder="{% amount_placeholder %}"/>' +
      '                </div>' +
      '            </div>' +
      '            <div class="mortgage--footer">' +
      '                <button class="go--button">' +
      '                    <p class="go--button__text">{% go_button_text %}</p>' +
      '                    <div class="goarrow">' +
      '                        <div class="goarrow--body"></div>' +
      '                    </div>' +
      '                </button>' +
      '            </div>' +
      '        </div>' +
      '        <div class="panel--overlay">' +
      '            <div class="icon--checkWrapper fromBottom circle">' +
      '                <div class="check"></div>' +
      '            </div>' +
      '            <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" aria-hidden="true" class="icon--redoWrapper">' +
      '                <div class="redo"></div>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    return { base: base }
  },
  mortgage: {},
  drawCircle: function () {
    var totalLoan = this.mortgage.loan_total,
      totalAmount = (totalLoan.replace(/\./g, '').replace(/\,/g, '.') * 1).toFixed(2),
      reduceAmount = this.input.get('value') || 0,
      percentage = (reduceAmount / totalAmount) * 100,
      max = (this.mortgage.loan_pay_nofine / 100) * 360,
      total = 180 * Math.PI,
      piesize = total * (percentage / 100)

    this.graph.setStyles({
      'stroke-dasharray': piesize + ',' + total,
    })

    this.graph_max.setStyles({
      transform: 'rotate(' + max + 'deg)',
    })

    this.updatePercentage(percentage)
  },
  updatePercentage: function (percentage) {
    this.graph_pct.set('html', percentage.toFixed(1) + '%')
  },
  updateAmount: function (percentage) {
    var totalLoan = this.mortgage.loan_total,
      totalLoan = (totalLoan.replace(/\./g, '').replace(/\,/g, '.') * 1).toFixed(2)
    var amount = Math.floor(totalLoan * (percentage / 100))

    if (this.input.get('value') != amount) {
      this.input.set('value', amount)
    }
  },
  percentageUpDown: function (direction) {
    var current = this.graph_pct.get('text')[0]
    current = current.replace(/\%/g, '') * 1
    current = Math.round(current)

    switch (direction) {
      case 'up':
        current = current + 1
        break
      case 'down':
        current = current - 1
        break
    }

    if (current >= 0 && current <= this.mortgage.loan_pay_nofine) {
      this.updateAmount(current)
      this.requestUpdate()
    }
  },
  updateMortgage: function (data) {
    this.drawCircle()

    this.graph_rest.set('text', data.data.remaining)
    this.graph_month.set('text', data.data.monthly)
  },
  requestUpdate: function () {
    var apiData = {
      type: 'mortgage_impact',
      reduce: this.input.get('value'),
      mortgage: this.mortgage,
    }

    this.apiCallback(apiData, this.updateMortgage.bind(this))
  },
  attach: function () {
    //set variables.
    this.mortgage = JSON.decode(this.element.get('data-mortgage'))
    this.input = this.element.getElements('#id_pay_amount')
    this.button = this.element.getElements('.go--button')[0]
    this.updown = this.element.getElements('.pm--button')
    this.graph = this.element.getElements('#graph--pay')
    this.graph_max = this.element.getElements('#mortgage_limit')
    this.graph_pct = this.element.getElements('#mortgage_percentage')
    this.graph_rest = this.element.getElements('#mortgage_rest')[0]
    this.graph_month = this.element.getElements('#mortgage_month')[0]

    this.input.addEvents({
      keydown: function (e) {
        var allowedKeys = new RegExp(/\d|backspace|enter|left|right|top|down/, 'i')
        if (allowedKeys.test(e.key.toString())) {
          this.requestUpdate()
        } else {
          e.preventDefault()
          return
        }
      }.bind(this),
      keyup: function () {
        if (this.input.get('value')) {
          this.input.getParent().addClass('hasData')
        } else {
          this.input.getParent().removeClass('hasData')
        }
      }.bind(this),
      blur: function () {
        if (this.input.get('value')) {
          this.input.getParent().addClass('hasData')
        } else {
          this.input.getParent().removeClass('hasData')
        }
      }.bind(this),
    })

    this.button.addEvents({
      click: function () {
        if (this.input.get('value') >= 500) {
          this.after()
        }
      }.bind(this),
    })

    this.updown.each(
      function (oButton, index) {
        oButton.addEvents({
          click: function () {
            if (oButton.hasClass('minus')) {
              this.percentageUpDown('down')
            } else {
              this.percentageUpDown('up')
            }
          }.bind(this),
        })
      }.bind(this)
    )

    this.requestUpdate()
  },
  after: function () {
    var answerData = {
      answer: {
        render: false,
        value: this.input.get('value'),
        content: this.input.get('value'),
      },
    }

    this.element.addClass('isAnswered')
    this.answerCallback(this.data, answerData)
  }
})
